// Einheitlich die aktuelle User-ID extrahieren
export function getUserId(user) {
  return String(user?._id || user?.id || user?.userId || '');
}

// Hilfsfunktion, um aus Message-Feldern IDs zu ziehen
export function toId(val) {
  if (!val) return '';
  if (typeof val === 'object') {
    if (val._id) return String(val._id);
    if (val.id) return String(val.id);
  }
  return String(val);
}

